function getToken() {

  $.ajax({
    url: mm_salesforce_apiurl.get_token,
    type: "post",
    contentType: false,
    processData: false,
    async: false,
    dataType: "json",
    success: function (d) {
      let json = JSON.parse(d);
      token = json.access_token
    },
  });
  return token;
}

function getPdfFromSalesforces($token, $invoiceNumber) {

  let formData = new FormData();

  formData.append("token", $token);
  formData.append("invoiceNumber", $invoiceNumber);
  pdfFromSalesforce = '';
  $.ajax({
    url: mm_salesforce_apiurl.get_pdf_from_salesforce,
    type: "post",
    data: formData,
    contentType: false,
    processData: false,
    async: false,
    dataType: "json",
    success: function (d) {
      pdfFromSalesforce = d
    },
  });
  return pdfFromSalesforce;
}

window.$ = window.jQuery = require("jquery");

$(document).ready(function () {

  $(document).on('click', '.invoice_pdf', function () {
    $token = getToken();
    $invoiceNumber = $(this).data('invoice_number');

    $url_of_facture = getPdfFromSalesforces($token, $invoiceNumber)

    window.open($url_of_facture);
  })
})



